import Vue from 'vue'
import * as signalR from '@microsoft/signalr'

// initialization SignalR
Vue.signalR = Vue.prototype.$signalR = signalR
